import { TFaqData } from './types';
import { ROUTE_PATH_CONTACTS, ROUTE_PATH_ALL_BOOKS } from 'app/app-routing.constants';

const contactsHref = `${location.origin}/${ROUTE_PATH_CONTACTS}`;
const allBooksHref = `${location.origin}/${ROUTE_PATH_ALL_BOOKS}`;

export const faqData: TFaqData = [
  {
    question: '支払いには何が使えますか？',
    answer: '各種クレジットカードまたはコンビニ払い（ファミリーマート、ローソン、ミニストップ、セイコーマート）がご利用いただけます。コンビニ払いでは、コンビニでのお支払いをもってご注文完了となります。',
  },
  {
    question: 'コンビニ払いの手順がわかりません。',
    answer: '手順や期限をご案内しますので、<a href="' + contactsHref + '">各種お問い合わせ窓口</a>からBÜKIカスタマーサポートへお問い合わせください。お急ぎの場合はLINEでお問い合わせください。',
  },
  {
    question: 'いつ届きますか？',
    answer: 'ご注文時にwebサイトに記載があった最短発送日に、兵庫県より発送いたします。到着予定日については、<a href="' + contactsHref + '">各種お問い合わせ窓口</a>からBÜKIカスタマーサポートへお問い合わせください。<br><br>なお、コンビニ払いの場合は、コンビニでのお支払いをもってご注文完了となりますため、最短発送日でお送りするお支払い期限までにお支払いがされなかった場合は、発送は次の発送になりますのでご注意ください。',
  },
  {
    question: '発送方法は何がありますか？',
    answer: '１冊の場合：ネコポス（ポスト投函）か宅急便（対面受け渡し）をお選びいただけます。<br>２冊～４冊の場合：宅急便（対面受け渡し）でお届けします。<br><br>どちらも追跡番号が発行され、発送時にメールでご案内しております。日時指定は現在できません。',
  },
  {
    question: '送料はいくらかかりますか？',
    answer: `ネコポスは全国一律385円（税込）です。宅急便は発送先により異なります、以下↓の料金表をご覧ください。
      <br>
      <br>
      <table>
        <tr>
          <th>発送先</th>
          <th>送料（税込）</th>
        </tr>
        <tr>
          <td>北海道</td>
          <td>1,770円</td>
        </tr>
        <tr>
          <td>北東北</td>
          <td>1,150円</td>
        </tr>
        <tr>
          <td>南東北</td>
          <td>1,030円</td>
        </tr>
        <tr>
          <td>関東</td>
          <td>880円</td>
        </tr>
        <tr>
          <td>信越</td>
          <td>870円</td>
        </tr>
        <tr>
          <td>北陸</td>
          <td>870円</td>
        </tr>
        <tr>
          <td>中部</td>
          <td>870円</td>
        </tr>
        <tr>
          <td>関西</td>
          <td>770円</td>
        </tr>
        <tr>
          <td>中国</td>
          <td>780円</td>
        </tr>
        <tr>
          <td>四国</td>
          <td>870円</td>
        </tr>
        <tr>
          <td>九州</td>
          <td>910円</td>
        </tr>
        <tr>
          <td>沖縄</td>
          <td>1,630円</td>
        </tr>
      </table>`,
  },
  {
    question: '発送を早めることはできますか？',
    answer: '申し訳ございません、印刷工場でのスケジュールが決まっているため、ご案内している最短発送日より早く送ることはできません。',
  },
  {
    question: '注文後のキャンセル・修正はできますか？',
    answer: 'オーダーメイドのためご注文後のキャンセル・修正をすることはできません。お会計前に主人公の情報に間違い・メッセージに誤字などがないか、ご確認ください。',
  },
  {
  question: 'コンビニ払いの期限が切れてしまいました。',
  answer: '期限切れにより、ご注文は取り消しされましたので、恐れ入りますが再度サイトからご注文をお願いします。なお、お支払い等にあたりご不明な点がありましたら、お気軽に<a href="' + contactsHref + '">BÜKIお問い合わせ窓口</a>にご連絡ください。',
  },
  {
    question: 'ギフトラッピングはできますか？',
    answer: '申し訳ありません、現在は資材を用意していなくギフトラッピングはありません。ただ、絵本をお届けする箱はお子様が開けるときからワクワクしてもらえるようにクマの郵便局員さんが抱えるデザインをしています。あくまで梱包資材のため発送伝票は貼られてしまいますので、ご了承ください。<br>実際のイメージは<a target="_blank" href="https://www.instagram.com/p/CLdvPJFjbVt/">こちら</a>をご覧ください。',
  },
  {
    question: '表紙はどんな種類がありますか？',
    answer: '文庫本のような柔らかくめくりやすいソフトカバーと、耐久性のある固いハードカバー（＋税込1000円）をご用意しています。特に贈り物であれば丈夫なハードカバーがおすすめです。',
  },
  {
    question: 'どんな紙を使っていますか？',
    answer: 'マットでザラリとした手触りと厚みのある、高級紙を使用しています。基準に従って適切に管理された森から生産された用紙で、地球に優しい取り組みに基づいて作られた紙です。',
  },
  {
    question: '注文者とは違う住所に届けることはできますか？',
    answer: 'はい。<br>カートの後のお客さま情報入力の画面で、“上記と同じ住所に送る”のチェックを外してお届け先の情報を入力してください。商品には領収書など金額がわかるものを同封していませんので、ギフトとしてもお送りいただけます。ご注文者さまの情報は、配達伝票に「依頼人」として記載されます。',
  },
  {
    question: '注文メールが届きません。',
    answer: '現在、キャリア系のメールアドレス（特に@au.com や @ezweb.ne.jp）をご利用のお客さまから「注文メールが届かない」とのお問い合わせが多く発生しております。設定等によりこちらからのメールが迷惑メールとして扱われている場合があります。<br><br>注文メールが届かないお客さまは、恐れ入りますが<a href="' + contactsHref + '">お問い合わせページ</a>に記載のLINE窓口もしくはお電話でご連絡ください。<br><br>なお、docomoをご利用で”パソコンメール受信拒否”に設定している場合は、設定の変更をお願いします。',
  },
  {
    question: '領収書を発行できますか？',
    answer: 'ギフトとしてお送りいただく場合もあるため、商品には金額がわかる明細書や領収書を同封しておりません。領収書が必要な場合は、お手数ですが yay@hellobuki.com 宛に【ご注文番号】を記載のうえ、メールでご連絡ください。',
  },
  {
    question: '兄弟姉妹・双子など、主人公を複数人にしてお話を作ってくれますか？',
    answer: '現在ご用意している絵本では主人公はどれもお一人のみとなります。今後複数人を主人公にした絵本も発売していく予定です。どうぞお待ちいただければ幸いです。',
  },
  {
    question: '届いた絵本に誤字・誤植がありました。',
    answer: '<a href="' + contactsHref + '">お問い合わせページ</a>に記載のBÜKIカスタマーサポートまでご連絡をお願いします。新しいものと交換いたします。<br>なお、メッセージ部分はお客様がご入力いただいたままで印刷されますためため、誤字があったとしても交換の対象外となります。',
  },
  {
    question: '主人公の髪型や服装を変えられますか？',
    answer: '現在はそれぞれの絵本でご用意している主人公のイメージのみとなります。今後、もっといろんな主人公のイメージでお作りできるよう、進めています。どうぞお待ちいただければ幸いです。',
  },
  {
    question: 'たくさん注文したいです。',
    answer: '一度のご注文で上限を4冊とさせていただいています。5冊以上ご注文の場合は、恐れ入りますがご注文を分けて入力ください。',
  },
  {
    question: '海外に発送はできますか？ Do you ship overseas?',
    answer: '申し訳ございません、現在日本国内のみの発送とさせていただいています。 Sorry, currently we only ship within Japan. No international shipping.',
  },
  {
    question: '商品を受け取ることができませんでした。',
    answer: 'ご不在が長く続いた場合や、住所の入力間違いで商品を受け取ることができなかった場合、商品は当社に返送されます。その場合は着払いにてお客さまご指定のご住所に再送させていただきます。',
  },
  {
    question: '写真をアップロードできません。',
    answer: '写真はJPEG、PNGもしくはHEICの形式で、100KB以上20MB以下のものを使用できます。アップロード後、反映までに20秒ほどかかりますので、お待ちいただきますようお願いします。<br>反映までに長く時間がかかる場合は、通信環境の良いところで再度お試しください。',
  },
  {
    question: '作ってほしい絵本があります。',
    answer: '今後制作する絵本のアイデアの参考にさせていただきます🥰 <a href="' + contactsHref + '">お問い合わせページ</a>に記載のBÜKIカスタマーサポートまでご連絡をお願いします。',
  },
  {
    question: '購入したギフトコードはどうやったらわかりますか？',
    answer: 'お支払い完了後にBÜKIから送信されるメールに（クレジットカードでお支払いの場合は、お支払い完了後の画面にも）ギフトコードを記載しています。<br><br>メールが届いていない場合は、恐れ入りますが公購入したギフトコードはどうやったらわかりますか？<br>式LINEや電`話で<a href="' + contactsHref + '">お問い合わせ</a>ください。',
  },
  {
    question: 'ギフトコードを相手に渡すにはどうしたらいいですか？',
    answer: 'お客さまご自身で、BÜKIから送られたギフトコードやリンク先を、相手の方にメールやLINE、SNS等でお知らせください。<br><br>ギフトコードが印刷されたカードがお手元に届くことはありませんので、ご注意ください。',
  },
  {
    question: 'ギフトコードの購入前に絵本の内容を確認できますか？',
    answer: '<a href="' + allBooksHref + '">こちら</a>からお好きな絵本をお選びいただき、仮のお子様のお名前等を入れれば、絵本の試し読みができます。',
  },
  {
    question: '絵本の発送・送料はどうなりますか？',
    answer: 'ギフトコードには、全て送料込みのお値段でご案内しております。なお、発送方法はネコポス（郵便ポスト受け取り・日時指定なし・追跡あり）のみとなります。<br><br>ギフトコードを受け取った方がお手続きを終了後、最短で（概ね１週間以内）発送しております。',
  },
  {
    question: '購入したギフトコードはキャンセルできますか？',
    answer: '申し訳ありません、ご購入後のキャンセル・返金には対応できません。',
  },
  {
    question: 'ギフトコードに有効期限はありますか？',
    answer: 'ご購入後の有効期限は１年間です。<br>未使用のまま期限を過ぎた場合でも、<a href="' + contactsHref + '">お問い合わせ</a>いただければ新しいギフトコードを発行いたします。',
  },
  {
    question: '複数のギフトコードを購入したいです。',
    answer: '申し訳ございません、現在は１回のご注文で１冊分のギフトコードをご購入いただけます。<br><br>複数のギフトコードをお求めの場合は、恐れ入りますがご注文を分けてお手続きお願いします。',
  },
];

export const faqDataCondensed: TFaqData = faqData.slice(0, 4);
